import React from "react";
import {
  MDBBadge,
  MDBIcon,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
  MDBInput,
} from "mdb-react-ui-kit";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Form from "react-bootstrap/Form";

import profile_default from "images/profile_default.png";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { mfmMediumUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { PopConfirm } from "Projects/CC_cubi_clan_project/GlobalComponents/PopConfirm/PopConfirm";
import { CircleImage } from "Projects/CC_cubi_clan_project/GlobalComponents/CircleImage/CircleImage";
import { UserNewModal } from "..//UserNewModal/UserNewModal";
import { UserEditModal } from "..//UserEditModal/UserEditModal";
import { AuditoriaAccesos } from "../AuditoriaAccesos/AuditoriaAccesos";

import "../sso-management.css";
import "./GestionUsuarios.css";

export class GestionUsuarios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      userGruposMap: {},
      grupoAppsMap: {},
      allGrupos: [],
      allApps: [],
      filterText: "",
      filterGrupo: "",
      filterApp: "",
      filterEstado: "",
      showUserNewModal: false,
      showUserEditModal: false,
      showUserDeleteAlert: false,
      showLoginHistoryModal: false,
      selectedUserEdit: null,
      selectedUserDelete: null,
      selectedUserLoginHistory: null,
      loginHistoryData: [],
      loginHistoryFilter: "all",
      loadingLoginHistory: false,
      subTab: "usuarios",
    };
  }

  componentDidMount() {
    this.getUsers();
    this.loadGrupoAppsMap();
    this.loadFilterOptions();
  }

  loadFilterOptions() {
    doFetch("SSO", "getAllGrupos", null)
      .then((r) => r.json())
      .then((d) => { if (d.DATA) this.setState({ allGrupos: d.DATA }); })
      .catch(() => {});
    doFetch("SSO", "getAllAplicaciones", null)
      .then((r) => r.json())
      .then((d) => { if (d.DATA) this.setState({ allApps: d.DATA }); })
      .catch(() => {});
  }

  getFilteredData() {
    let data = this.state.data;
    const { filterText, filterGrupo, filterApp, filterEstado, userGruposMap, grupoAppsMap } = this.state;

    if (filterText.trim()) {
      const f = filterText.toLowerCase();
      data = data.filter((u) =>
        (u.apodo || "").toLowerCase().includes(f) ||
        (u.nombre || "").toLowerCase().includes(f) ||
        (u.apellido || "").toLowerCase().includes(f) ||
        (u.email || "").toLowerCase().includes(f)
      );
    }

    if (filterEstado) {
      const active = filterEstado === "1";
      data = data.filter((u) => !!u.activo === active);
    }

    if (filterGrupo) {
      const gid = parseInt(filterGrupo);
      data = data.filter((u) => {
        const grupos = userGruposMap[u.IDUsuario] || [];
        return grupos.some((g) => g.IDGrupo === gid);
      });
    }

    if (filterApp) {
      data = data.filter((u) => {
        const grupos = userGruposMap[u.IDUsuario] || [];
        return grupos.some((g) => (grupoAppsMap[g.IDGrupo] || []).includes(filterApp));
      });
    }

    return data;
  }

  getUsers() {
    this.props.onLoading(true);

    doFetch("SSO", "getAllUsers", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ data: data.DATA });
        // Load groups for each user
        for (let user of data.DATA) {
          this.getUserGrupos(user.IDUsuario);
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  getUserGrupos(idUsuario) {
    let method = "getUserGrupos?IDUsuario=" + idUsuario;
    doFetch("SSO", method, null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          let map = { ...this.state.userGruposMap };
          map[idUsuario] = data.DATA;
          this.setState({ userGruposMap: map });
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      });
  }

  loadGrupoAppsMap() {
    doFetch("SSO", "getAllGrupos", null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          let map = {};
          for (let grupo of data.DATA) {
            if (grupo.IDGrupo) {
              doFetch("SSO", "getGrupo?IDGrupo=" + grupo.IDGrupo, null)
                .then((r) => r.json())
                .then((d) => {
                  if (d.DATA && d.DATA.aplicaciones) {
                    map[grupo.IDGrupo] = d.DATA.aplicaciones.map(a => a.appNombre);
                    this.setState({ grupoAppsMap: { ...map } });
                  }
                })
                .catch(() => {});
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error loading group apps:", JSON.stringify(error, null, 2));
      });
  }

  setNewUser() {
    this.setState({ showUserNewModal: true });
  }

  setEditUser(element) {
    this.setState({ showUserEditModal: true, selectedUserEdit: element });
  }

  handleCloseModal() {
    this.setState({ showUserEditModal: false, showUserNewModal: false });
    this.getUsers();
  }

  confirmUserDelete(element) {
    this.setState({ showUserDeleteAlert: true, selectedUserDelete: element });
  }

  formatDateTime(dateValue) {
    if (!dateValue) return "-";
    const parsed = new Date(dateValue);
    if (Number.isNaN(parsed.getTime())) return String(dateValue);
    return parsed.toLocaleString("es-ES", { hour12: false });
  }

  openLoginHistoryModal(user) {
    this.setState(
      {
        showLoginHistoryModal: true,
        selectedUserLoginHistory: user,
        loginHistoryData: [],
      },
      () => this.getUserLoginHistory(user.IDUsuario, user.apodo)
    );
  }

  closeLoginHistoryModal() {
    this.setState({
      showLoginHistoryModal: false,
      selectedUserLoginHistory: null,
      loginHistoryData: [],
      loginHistoryFilter: "all",
      loadingLoginHistory: false,
    });
  }

  setShowLoginHistory(event) {
    if (this.state.showLoginHistoryModal !== event) {
      if (!event) {
        this.closeLoginHistoryModal();
      }
    }
  }

  getUserLoginHistory(idUsuario, apodo) {
    this.setState({ loadingLoginHistory: true });

    let method = "getLoginAudit?pageSize=100";
    if (idUsuario) method += "&idUsuario=" + idUsuario;
    if (apodo)    method += "&apodo=" + encodeURIComponent(apodo);

    doFetch("SSO", method, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ loginHistoryData: data.DATA || [] });
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
        this.setState({ loginHistoryData: [] });
      })
      .finally(() => {
        this.setState({ loadingLoginHistory: false });
      });
  }

  getResultadoBadgeColor(resultado) {
    switch (resultado) {
      case "SUCCESS": return "success";
      case "FAIL_CREDENTIALS": return "danger";
      case "FAIL_USER_NOT_FOUND": return "warning";
      case "FAIL_INACTIVE": return "secondary";
      case "FAIL_LOCKED": return "warning";
      case "EXCEPTION": return "dark";
      default: return "secondary";
    }
  }

  getResultadoLabel(resultado) {
    switch (resultado) {
      case "SUCCESS": return "Éxito";
      case "FAIL_CREDENTIALS": return "Contraseña incorrecta";
      case "FAIL_USER_NOT_FOUND": return "Usuario no encontrado";
      case "FAIL_INACTIVE": return "Usuario inactivo";
      case "FAIL_LOCKED": return "Bloqueado";
      case "EXCEPTION": return "Error interno";
      default: return resultado || "-";
    }
  }

  getFilteredLoginHistory() {
    const { loginHistoryData, loginHistoryFilter } = this.state;
    if (!loginHistoryFilter || loginHistoryFilter === "all") return loginHistoryData;
    if (loginHistoryFilter === "success") return loginHistoryData.filter((r) => r.resultado === "SUCCESS");
    if (loginHistoryFilter === "fail") return loginHistoryData.filter((r) => r.resultado !== "SUCCESS");
    return loginHistoryData;
  }

  async handlerConfirmDeleteUser() {
    this.setState({ showUserDeleteAlert: false });
    let res = await this.deleteUser();
    if (res) {
      this.getUsers();
    }
  }

  handlerCancelDeleteUser() {
    this.setState({ showUserDeleteAlert: false, selectedUserDelete: null });
  }

  async deleteUser() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "DELETE",
    };

    let method =
      "deleteUser?IDUsuario=" + this.state.selectedUserDelete.IDUsuario;

    await doFetch("SSO", method, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  render() {
    return (
      <MDBContainer fluid>
        {this.state.showUserEditModal ? (
          <UserEditModal
            showUserEditModal={this.state.showUserEditModal}
            data={this.state.selectedUserEdit}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showUserNewModal ? (
          <UserNewModal
            showUserNewModal={this.state.showUserNewModal}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showUserDeleteAlert ? (
          <PopConfirm
            show={this.state.showUserDeleteAlert}
            title="Confirmar borrar usuario"
            detail="¿Está seguro de que desea borrar el usuario?"
            onConfirm={() => this.handlerConfirmDeleteUser()}
            onCancel={() => this.handlerCancelDeleteUser()}
          />
        ) : (
          <></>
        )}
        {this.state.showLoginHistoryModal ? (
          <MDBModal
            tabIndex="-1"
            show={this.state.showLoginHistoryModal}
            setShow={(event) => this.setShowLoginHistory(event)}
          >
            <MDBModalDialog size="lg" scrollable>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>
                    Histórico de logins: {this.state.selectedUserLoginHistory?.apodo || "usuario"}
                  </MDBModalTitle>
                  <MDBBtn className="btn-close" color="none" onClick={() => this.closeLoginHistoryModal()} />
                </MDBModalHeader>
                <MDBModalBody>
                  <div className="mb-2 d-flex gap-2 align-items-center">
                    <small className="text-muted">Filtrar:</small>
                    <Form.Select
                      size="sm"
                      style={{ width: "210px" }}
                      value={this.state.loginHistoryFilter}
                      onChange={(e) => this.setState({ loginHistoryFilter: e.target.value })}
                    >
                      <option value="all">Todos</option>
                      <option value="success">Solo éxitos</option>
                      <option value="fail">Solo fallos</option>
                    </Form.Select>
                  </div>
                  <MDBTable align="middle" striped hover responsive>
                    <MDBTableHead>
                      <tr>
                        <th scope="col">Fecha</th>
                        <th scope="col">Resultado</th>
                        <th scope="col">App</th>
                        <th scope="col">IP</th>
                        <th scope="col">Dispositivo</th>
                        <th scope="col">Detalle</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.getFilteredLoginHistory().map((row) => (
                        <tr key={row.idAudit}>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <small>{this.formatDateTime(row.fechaIntento)}</small>
                          </td>
                          <td>
                            <MDBBadge color={this.getResultadoBadgeColor(row.resultado)} pill>
                              {this.getResultadoLabel(row.resultado)}
                            </MDBBadge>
                          </td>
                          <td>
                            {row.appCode ? (
                              <MDBBadge color="info" pill>{row.appCode}</MDBBadge>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td><small>{row.ip || "-"}</small></td>
                          <td>
                            {row.userAgent ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>{row.userAgent}</Tooltip>}
                              >
                                <small
                                  className="text-truncate d-inline-block"
                                  style={{ maxWidth: 160, cursor: "help" }}
                                >
                                  {row.userAgent.length > 50
                                    ? row.userAgent.substring(0, 50) + "…"
                                    : row.userAgent}
                                </small>
                              </OverlayTrigger>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td><small>{row.detalle || "-"}</small></td>
                        </tr>
                      ))}
                    </MDBTableBody>
                  </MDBTable>
                  {!this.state.loadingLoginHistory &&
                  (!this.getFilteredLoginHistory() || this.getFilteredLoginHistory().length === 0) ? (
                    <p className="text-muted mb-0">No hay registros para este usuario.</p>
                  ) : (
                    <></>
                  )}
                  {this.state.loadingLoginHistory ? <p className="text-muted mb-0">Cargando histórico...</p> : <></>}
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        ) : (
          <></>
        )}
        {!this.props.hideSectionNavigation ? <div className="d-flex gap-2 px-3 pt-3 border-bottom mb-0">
          <button
            className={"btn btn-sm me-1" + (this.state.subTab === "usuarios" ? " btn-primary" : " btn-outline-secondary")}
            onClick={() => this.setState({ subTab: "usuarios" })}
          >
            Usuarios
          </button>
          <button
            className={"btn btn-sm" + (this.state.subTab === "auditoria" ? " btn-primary" : " btn-outline-secondary")}
            onClick={() => this.setState({ subTab: "auditoria" })}
          >
            Auditoría de accesos
          </button>
        </div> : null}
        {!this.props.hideSectionNavigation && this.state.subTab === "auditoria" ? (
          <AuditoriaAccesos onLoading={this.props.onLoading} />
        ) : null}
        <div style={{ display: this.props.hideSectionNavigation || this.state.subTab === "usuarios" ? undefined : "none" }}>
        <MDBContainer fluid className="mt-3 mb-2">
          <MDBRow className="align-items-end g-2">
            <MDBCol md="3">
              <MDBInput
                type="text"
                size="sm"
                label="Buscar usuario..."
                value={this.state.filterText}
                onChange={(e) => this.setState({ filterText: e.target.value })}
              />
            </MDBCol>
            <MDBCol md="2">
              <Form.Select
                size="sm"
                value={this.state.filterGrupo}
                onChange={(e) => this.setState({ filterGrupo: e.target.value })}
              >
                <option value="">Todos los grupos</option>
                {this.state.allGrupos.map((g) => (
                  <option key={g.IDGrupo} value={g.IDGrupo}>{g.nombre}</option>
                ))}
              </Form.Select>
            </MDBCol>
            <MDBCol md="2">
              <Form.Select
                size="sm"
                value={this.state.filterApp}
                onChange={(e) => this.setState({ filterApp: e.target.value })}
              >
                <option value="">Todas las apps</option>
                {this.state.allApps.map((a) => (
                  <option key={a.IDAplicacion} value={a.nombre}>{a.titulo || a.nombre}</option>
                ))}
              </Form.Select>
            </MDBCol>
            <MDBCol md="2">
              <Form.Select
                size="sm"
                value={this.state.filterEstado}
                onChange={(e) => this.setState({ filterEstado: e.target.value })}
              >
                <option value="">Todos</option>
                <option value="1">Activos</option>
                <option value="0">Inactivos</option>
              </Form.Select>
            </MDBCol>
            <MDBCol md="3" className="d-flex justify-content-end">
              <MDBBtnGroup>
                <MDBBtn size="sm" onClick={() => this.setNewUser()}>
                  <MDBIcon icon="plus" className="me-1" /> Nuevo usuario
                </MDBBtn>
              </MDBBtnGroup>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <MDBTable align="middle" hover responsive className="sso-mgmt-table">
          <MDBTableHead>
            <tr>
              <th scope="col">Usuario</th>
              <th scope="col">Grupos</th>
              <th scope="col">Estado</th>
              <th scope="col">Apps</th>
              <th scope="col" style={{ width: "120px" }}>Acciones</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {this.getFilteredData().map((element, index) => {
              const grupos = this.state.userGruposMap[element.IDUsuario] || [];
              const appNames = [...new Set(grupos.flatMap(g => this.state.grupoAppsMap[g.IDGrupo] || []))];
              const MAX_BADGES = 3;
              return (
              <tr key={index}>
                <td>
                  <div className="sso-user-identity">
                    <CircleImage
                      src={element.imageUuid ? mfmMediumUrl(element.imageUuid) : (element.userImg || profile_default)}
                      alt={element.apodo}
                      size="36px"
                      enlargeOnHover={true}
                      onClick={() => this.setEditUser(element)}
                    />
                    <div>
                      <p className="sso-user-name mb-0">{element.apodo}</p>
                      <p className="sso-user-fullname mb-0">
                        {[element.nombre, element.apellido].filter(Boolean).join(" ")}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="sso-badge-cell">
                  <div className="sso-badge-overflow">
                    {grupos.length > 0 ? (
                      <>
                        {grupos.slice(0, MAX_BADGES).map((g, gi) => (
                          <MDBBadge key={gi} color="info" pill className="me-1 mb-1">{g.nombre}</MDBBadge>
                        ))}
                        {grupos.length > MAX_BADGES && (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{grupos.slice(MAX_BADGES).map(g => g.nombre).join(", ")}</Tooltip>}
                          >
                            <span className="sso-badge-more">+{grupos.length - MAX_BADGES}</span>
                          </OverlayTrigger>
                        )}
                      </>
                    ) : (
                      <span className="text-muted" style={{ fontSize: "0.8rem" }}>Sin grupos</span>
                    )}
                  </div>
                </td>
                <td>
                  <MDBBadge color={element.activo ? "success" : "danger"} pill>
                    {element.activo ? "Activo" : "Inactivo"}
                  </MDBBadge>
                </td>
                <td className="sso-badge-cell">
                  <div className="sso-badge-overflow">
                    {appNames.length > 0 ? (
                      <>
                        {appNames.slice(0, MAX_BADGES).map((name, ai) => (
                          <MDBBadge key={ai} color="primary" pill className="me-1 mb-1">{name}</MDBBadge>
                        ))}
                        {appNames.length > MAX_BADGES && (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{appNames.slice(MAX_BADGES).join(", ")}</Tooltip>}
                          >
                            <span className="sso-badge-more">+{appNames.length - MAX_BADGES}</span>
                          </OverlayTrigger>
                        )}
                      </>
                    ) : (
                      <span className="text-muted" style={{ fontSize: "0.8rem" }}>—</span>
                    )}
                  </div>
                </td>
                <td className="sso-actions-cell">
                  <OverlayTrigger placement="top" overlay={<Tooltip>Histórico</Tooltip>}>
                    <span className="d-inline-block">
                      <MDBBtn color="secondary" outline className="mx-1" floating size="sm" onClick={() => this.openLoginHistoryModal(element)}>
                        <MDBIcon icon="history" />
                      </MDBBtn>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>Editar</Tooltip>}>
                    <span className="d-inline-block">
                      <MDBBtn color="primary" outline className="mx-1" floating size="sm" onClick={() => this.setEditUser(element)}>
                        <MDBIcon icon="edit" />
                      </MDBBtn>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>Eliminar</Tooltip>}>
                    <span className="d-inline-block">
                      <MDBBtn color="danger" outline className="mx-1" floating size="sm" onClick={() => this.confirmUserDelete(element)}>
                        <MDBIcon icon="times" />
                      </MDBBtn>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              );
            })}
          </MDBTableBody>
        </MDBTable>
      </div>
      </MDBContainer>
    );
  }
}
